import { format, parseISO, differenceInCalendarDays } from "date-fns";
import { CheckCircle2, Send } from "lucide-react";
import { fmtDuration } from "@/lib/time";

const nice = (d) => format(parseISO(d), "EEE d MMM");

export default function PeriodCard({ s, canSubmit, onSubmit }) {
  if (!s) return null;
  const pct = s.expected_minutes ? Math.min(100, Math.round((s.logged_minutes / s.expected_minutes) * 100)) : 0;
  const left = differenceInCalendarDays(parseISO(s.end), new Date());
  return (
    <section className="relative overflow-hidden rounded-2xl bg-[#103080] text-white p-6 sm:p-8 ambient fade-up" data-testid="timesheet-period-card">
      <div className="absolute -right-20 -top-20 w-72 h-72 rounded-full bg-[#0090D0]/30 blur-3xl" />
      <div className="relative grid md:grid-cols-[1fr_auto] gap-6 items-end">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-[#40C0E0] font-semibold">{s.label} pay period</p>
          <h2 className="font-serif-brand font-semibold text-3xl sm:text-4xl mt-3" data-testid="timesheet-banked-hours">
            {fmtDuration(s.logged_minutes)} <i className="text-[#40C0E0] text-2xl">banked</i>
          </h2>
          <p className="text-white/70 text-sm mt-2" data-testid="timesheet-period-dates">
            Hours from {nice(s.start)} to {nice(s.end)} · paid {nice(s.pay_date)}
            {left >= 0 ? ` · ${left} day${left === 1 ? "" : "s"} left to log` : ""}
          </p>
          <div className="mt-4 h-2 rounded-full bg-white/15 overflow-hidden max-w-xl">
            <div className="h-full bg-[#40C0E0] transition-[width] duration-500" style={{ width: `${pct}%` }} />
          </div>
          <p className="text-xs text-white/60 mt-1.5">{pct}% of {fmtDuration(s.expected_minutes)} working hours in this period</p>
        </div>
        {s.submitted_at ? (
          <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-5 h-11 text-sm font-semibold" data-testid="timesheet-submitted">
            <CheckCircle2 size={16} className="text-[#40C0E0]" /> Submitted {format(parseISO(s.submitted_at), "d MMM")}
          </span>
        ) : canSubmit && (
          <button onClick={onSubmit} data-testid="timesheet-submit-button"
            className="inline-flex items-center gap-2 rounded-full bg-white text-[#103080] font-semibold px-6 h-11 text-sm hover:bg-[#40C0E0] transition-colors duration-200">
            <Send size={15} /> Submit timesheet
          </button>
        )}
      </div>
    </section>
  );
}
